import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import fetchData from '../../service/apiService'
import { getEndpointFromConfig, parseCSVtoJSON } from '../utils/helper'
import { fetchAndSetPostMethodData } from '../commonSlice'
import { endpointLabels } from '../utils/enum'
import SectionCardContentLoader from './CardContentLoader/SectionCardContentLoader'
import { format } from 'date-fns'

const CountryAnalytics = ({ themeName, type, countryCode }) => {
  const { selectedTab, selectedEconomiesFeatured } = useSelector(
    (state) => state.countryProfile
  )
  const [productJson, setProductJson] = useState([])
  const [productDetails, setProductDetails] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [themeIdNo, setThemeIdNo] = useState([])
  const ctyAlyCompRef = useRef(null)
  const { endpointList, apiKeyName, apiKeyValue, featureProps, hierarchyData } =
    useSelector((state) => state.common)
  const dispatch = useDispatch()
  const {
    analyticsProductsLink,
    searchURLPublish,
    mode,
    searchURLAuthor,
    noDataImageURL,
    selector,
    countryAnalyticsProfileURLAuthor,
    countryAnalyticsProfileURLPublish,
  } = featureProps

  let searchUrl = ''
  if (mode === 'publish') {
    searchUrl = searchURLPublish
  } else {
    searchUrl = searchURLAuthor
  }

  useEffect(() => {
    if (hierarchyData?.codes) {
      hierarchyData?.codes.map((obj) => {
        if (obj.value === themeName) {
          setThemeIdNo(obj.id)
        }
      })
    }
  }, [themeName, hierarchyData])

  const getProductCSV = async () => {
    try {
      const response = await fetchData(analyticsProductsLink)

      if (response) {
        const jsonData = parseCSVtoJSON(response)
        let dataExtendedCore = []

        let tempDataCore = jsonData.filter((obj) =>
          type !== 'overview'
            ? obj.theme === themeName && obj.product_type === 'Core'
            : obj.product_type === 'Core'
        )

        tempDataCore.sort((a, b) =>
          a.product_name.localeCompare(b.product_name, undefined, {
            sensitivity: 'base',
          })
        )
        if (tempDataCore?.length < 4) {
          dataExtendedCore = jsonData.filter((obj) =>
            type !== 'overview'
              ? obj.theme === themeName && obj.product_type === 'Extended Core'
              : obj.product_type === 'Extended Core'
          )
          dataExtendedCore.sort((a, b) =>
            a.product_name.localeCompare(b.product_name, undefined, {
              sensitivity: 'base',
            })
          )
          tempDataCore = [...tempDataCore, ...dataExtendedCore]
        } else {
          tempDataCore = tempDataCore
        }

        tempDataCore.sort((a, b) =>
          a.product_name.localeCompare(b.product_name, undefined, {
            sensitivity: 'base',
          })
        )
        tempDataCore.length === 0 && setIsLoading(false)
        setProductJson(tempDataCore)
      }
    } catch (error) {
      setIsLoading(false)
      console.log('error hierarchy', error)
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (themeName) {
              setIsLoading(true)
              getProductCSV()
            }
            observer.unobserve(entry.target)
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    )

    if (ctyAlyCompRef.current) {
      observer.observe(ctyAlyCompRef.current)
    }

    return () => observer.disconnect()
  }, [themeName, selectedTab, analyticsProductsLink])

  const getProductDetails = async (filterString) => {
    let filterProduct = `type eq 'analytics' and (${filterString})`

    if (countryCode) {
      filterProduct += ` and (series_description/ref_country/any(item:(item/code eq '${countryCode}')))`
    }
    try {
      const request = {
        count: true,
        facets: ['product/name'],
        orderby: 'series_description/date_last_update desc',
        select:
          'metadata_information/title,series_description/date_last_update,series_description/ref_country,series_description/links, product/code',
        top: 1000,
        skip: 0,
        search: '*',
        filter: filterProduct,
      }
      const headers = apiKeyName ? { [apiKeyName]: apiKeyValue } : undefined
      const metadataResponse = await dispatch(
        fetchAndSetPostMethodData({
          endpointData: {
            endpoint: getEndpointFromConfig(
              endpointList,
              endpointLabels.Metadata
            ).apiEndpoint,
            method: 'POST',
            data: request,
            headers,
          },
          key: `featureddataset`,
        })
      )

      if (metadataResponse?.payload?.value?.length > 0) {
        let productDetailsList = productJson.map((data) => {
          let productCountryDetails = metadataResponse?.payload?.value.filter(
            (obj) => {
              return obj.product.code === data.product_code
            }
          )

          return {
            ...data,
            productDetails:
              productCountryDetails.length > 2
                ? productCountryDetails.slice(0, 2)
                : productCountryDetails,
          }
        })
        setProductDetails(productDetailsList)
        setIsLoading(false)
      } else {
        setProductDetails([])
        setIsLoading(false)
      }
    } catch (error) {
      console.error('Error fetching metadata in Featured Datasets:', error)
    }
  }

  useEffect(() => {
    if (productJson?.length) {
      let filterArray = []
      productJson.forEach((obj) => {
        filterArray.push(`product/code eq '${obj.product_code}'`)
      })
      const filterString = filterArray.join(' or ')
      getProductDetails(filterString)
    }
  }, [productJson])

  return !isLoading &&
    (!productDetails ||
      productDetails.filter((item) => item?.productDetails?.length !== 0)
        .length === 0) ? null : (
    <div
      className="container responsivegrid padd-b-48 touchui-container aem-GridColumn aem-GridColumn--default--122"
      id="economyAnalytics"
    >
      <div className="container responsivegrid aem-GridColumn aem-GridColumn--default--12">
        <div className="aem-Grid">
          <div className="title aem-GridColumn--xl--9 aem-GridColumn--default--9 aem-GridColumn--desktop--9 aem-GridColumn--tablet--9 aem-GridColumn--phone--12 aem-GridColumn--xs--12">
            <div className="cmp-title">
              <h3 ref={ctyAlyCompRef} className="cmp-title__text">
                Economy Analytics
              </h3>
            </div>
          </div>
          <div className="button view-all-link aem-GridColumn--xl--3 aem-GridColumn--default--3 aem-GridColumn--desktop--3 aem-GridColumn--tablet--3 aem-GridColumn--phone--12 aem-GridColumn--xs--12">
            <a
              className="cmp-button"
              href={`${searchUrl}?tab=analytics&country=${selector}${
                type !== 'overview' ? `&themeAndTopics=${themeIdNo}` : ''
              }`}
              data-customlink="nl:body content"
            >
              <span className="cmp-button__text">VIEW ALL</span>
            </a>
          </div>
        </div>
      </div>
      <div className="tui_column_grid tui__flex container responsivegrid aem-GridColumn aem-GridColumn--default--12">
        {!isLoading && productDetails?.length ? (
          productDetails
            ?.filter((item) => item?.productDetails?.length !== 0)
            .splice(0, 4)
            .map((obj, index) => {
              return (
                <div
                  key={index}
                  className="aem-GridColumn--xs--12 aem-GridColumn--phone--12 aem-GridColumn--tablet--6 aem-GridColumn--desktop--6 aem-GridColumn--default--6"
                >
                  <div className="tui__secondary_card horizontal">
                    <div className="tui__secondary_card_content">
                      <div className="tui__secondary_card_top">
                        <h3 className="tui_text_md">
                          <a
                            href={
                              mode === 'author'
                                ? `${countryAnalyticsProfileURLAuthor}.${obj.product_code}.html`
                                : `${countryAnalyticsProfileURLPublish}/${obj.product_code}`
                            }
                            data-customlink="nl:body content"
                          >
                            {obj.product_name}
                          </a>
                        </h3>
                        <div className="tui_text_base">
                          <p>{obj.description}</p>
                        </div>
                      </div>

                      <div className="tui__secondary_card_bottom">
                        <div className="tui_text_base">
                          Latest Economy Reports
                        </div>
                        <div className="tui__secondary_card_list">
                          <ul>
                            {obj.productDetails.map((item, idx) => {
                              return (
                                <li key={idx}>
                                  <div className="tui__secondary_card_listitem">
                                    <div className="tui_text_base">
                                      {
                                        item?.series_description
                                          .ref_country?.[0]?.name
                                      }
                                    </div>
                                    <div className="tui_text_sm">
                                      {format(
                                        item?.series_description
                                          .date_last_update,
                                        'MM/dd/yyyy'
                                      )}
                                    </div>
                                  </div>
                                  <p className="tui_text_sm">
                                    <a
                                      href={`${item?.series_description.links?.[0]?.uri}`}
                                      data-customlink="nl:body content"
                                    >
                                      {item?.metadata_information?.title}
                                    </a>
                                  </p>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                        {/* <div className="tui__secondary_card_btn view-all-link">
                          <a
                            href={`${searchUrl}?countryAnalytics=${
                              obj.product_code
                            }${
                              type !== 'overview'
                                ? `&themeAndTopics=${themeIdNo}`
                                : ''
                            }`}
                            className=""
                          >
                            View All
                          </a>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
        ) : (
          <SectionCardContentLoader />
        )}
      </div>
    </div>
  )
}

export default CountryAnalytics
